import React from 'react'
import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import IconContainer from './IconContainer'
import IconLabel from './IconLabel'

const OpenIcon = ({ label, color, variant }) => {
    return (
        <Box display="flex" alignItems="center">
            <IconContainer bgcolor="#d66a00">
                <Icon
                    style={{
                        marginLeft: '4px',
                    }}
                    name="Play"
                    color="#ffffff"
                />
            </IconContainer>
            <IconLabel style={{ color: '#d66a00' }}>{label}</IconLabel>
        </Box>
    )
}

export default OpenIcon
